import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// FIX: Lade till den explicita filändelsen .tsx för att säkerställa att kompilatorn hittar filen
import App from './App.tsx';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
